<small class="debug">{{me}}</small>
<h1 class="header" mat-dialog-title cdkDrag cdkDragRootElement=".cdk-overlay-pane">
  <div class="dlg-drag-handle" cdkDragHandle>
    <svg width="24px" fill="currentColor" viewBox="0 0 24 24">
      <path d="M10 9h4V6h3l-5-5-5 5h3v3zm-1 1H6V7l-5 5 5 5v-3h3v-4zm14 2l-5-5v3h-3v4h3v3l5-5zm-9 3h-4v3H7l5 5 5-5h-3v-3z"></path>
      <path d="M0 0h24v24H0z" fill="none"></path>
    </svg>
  </div>
  <mat-label>{{'general.eventExplorer' | transloco}}</mat-label>
</h1>
<div mat-dialog-content>
  @if (selection | async; as selected$) {
    <div>
      <button (click)="import($event)" disabled="{{!selected$.source || selected$?.source?.selected?.length == 0}}"
        style="margin: 10px; z-index: 10000; position: absolute; right: 45px; top: -1px" mat-raised-button color="warn">
        <mat-icon>downloading</mat-icon>
        {{'general.insert' | transloco}}
      </button>
    </div>
  }
  <app-events-explorer [selectedEvent]="m_data" (selectedModal)="onSelectedMode($event)"></app-events-explorer>
</div>
